import { render, staticRenderFns } from "./biPointLine.vue?vue&type=template&id=08cf09b0&"
import script from "./biPointLine.vue?vue&type=script&lang=js&"
export * from "./biPointLine.vue?vue&type=script&lang=js&"
import style0 from "./biPointLine.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports